// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kxoc","title":"styles_title__KogCh"};